(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vitanima-ruleta"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-vwheel-root]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const $ = (s) => root.querySelector(s);
    const teaser = $('[data-vwheel-open]');
    const mascot = $('[data-vwheel-mascot]');
    const dialog = $('[data-vwheel-dialog]');
    const close = $('[data-vwheel-close]');
    const disc = $('[data-vwheel-disc]');
    const entry = $('[data-vwheel-entry]');
    const result = $('[data-vwheel-result]');
    const prizeEl = $('[data-vwheel-prize]');
    const detailEl = $('[data-vwheel-detail]');
    const codeEl = $('[data-vwheel-code]');
    const codeBox = $('[data-vwheel-code-box]');
    const copy = $('[data-vwheel-copy]');
    const apply = $('[data-vwheel-apply]');
    const form = $('.vwheel__form');
    const submit = $('[data-vwheel-submit]');
    const confetti = $('[data-vwheel-confetti]');
    const prizeData = $('[data-vwheel-prizes]');
    const captured = Boolean($('[data-vwheel-capture-state="success"]'));
    const hasErrors = Boolean($('.vwheel__errors'));
    const storageKey = 'vitanima-wheel-prize-v5';
    const sentKey = 'vitanima-wheel-sent';
    const teaserDelay = 8000;
    let prizes = [];
    if (prizeData) {
      try { prizes = JSON.parse(prizeData.textContent); } catch (error) { prizes = []; }
    }
    const readValue = (key) => { try { return JSON.parse(localStorage.getItem(key)); } catch (error) { return null; } };
    const saveValue = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch (error) { return; } };
    const sentFlag = () => { try { return sessionStorage.getItem(sentKey) === '1'; } catch (error) { return false; } };
    const setSent = (on) => { try { if (on) sessionStorage.setItem(sentKey, '1'); else sessionStorage.removeItem(sentKey); } catch (error) { return; } };
    const randomNumber = (limit) => {
      if (window.crypto && window.crypto.getRandomValues) {
        const values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        return values[0] % limit;
      }
      return Math.floor(Math.random() * limit);
    };
    const loadMascot = () => { if (mascot && !mascot.src && mascot.dataset.src) mascot.src = mascot.dataset.src; };
    const decodePrize = (prize) => {
      if (!prize) return null;
      try { return { id: prize.id, label: prize.label, detail: prize.detail, segment: prize.segment, code: window.atob(prize.c || '') }; } catch (error) { return null; }
    };
    const burst = () => {
      if (!confetti || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      confetti.replaceChildren();
      const colors = ['#3f5a46', '#bd8c46', '#b86f55', '#fff1b8', '#7fa184'];
      for (let index = 0; index < 26; index += 1) {
        const piece = document.createElement('span');
        const angle = (Math.PI * 2 * index) / 26;
        const distance = 80 + randomNumber(100);
        piece.style.setProperty('--piece-x', Math.cos(angle) * distance + 'px');
        piece.style.setProperty('--piece-y', Math.sin(angle) * distance + 'px');
        piece.style.setProperty('--piece-rotate', randomNumber(180) + 'deg');
        piece.style.setProperty('--piece-color', colors[index % colors.length]);
        confetti.appendChild(piece);
      }
    };
    const showResult = (prize) => {
      entry.hidden = true;
      result.hidden = false;
      prizeEl.textContent = prize.label;
      detailEl.textContent = prize.detail;
      const hasCode = Boolean(prize.code);
      codeBox.hidden = !hasCode;
      if (hasCode) {
        codeEl.textContent = prize.code;
        apply.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent('/collections/all');
      }
    };
    const spin = (prize) => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const segment = Number(prize.segment) || 0;
      disc.style.animation = 'none';
      disc.style.transform = 'rotate(' + (2160 - segment * 30) + 'deg)';
      window.setTimeout(() => { saveValue(storageKey, prize); showResult(prize); burst(); }, reduce ? 30 : 4200);
    };
    const openDialog = () => {
      loadMascot();
      const stored = readValue(storageKey);
      if (stored && stored.id && stored.code) showResult(stored);
      if (!dialog.open) dialog.showModal();
    };
    const showTeaser = () => { loadMascot(); teaser.classList.add('is-ready'); };
    const scheduleTeaser = () => window.setTimeout(showTeaser, teaserDelay);
    if (document.readyState === 'complete') scheduleTeaser(); else window.addEventListener('load', scheduleTeaser, { once: true });
    teaser.addEventListener('click', openDialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    if (form && submit) form.addEventListener('submit', () => { setSent(true); window.setTimeout(() => { submit.disabled = true; }, 0); });
    copy.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(codeEl.textContent); copy.textContent = root.dataset.copiedLabel; } catch (error) { return; }
    });
    if (captured && sentFlag() && !readValue(storageKey)) {
      setSent(false);
      const won = decodePrize(prizes[0]);
      if (won && won.code) { openDialog(); window.setTimeout(() => spin(won), 350); }
    } else if (hasErrors) {
      setSent(false);
      openDialog();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
